<template>

    <el-form  size="small" class="dailt-form" :model="form" label-width="55px" ref="dailyTimeForm">
        <el-form-item label="开始：" >

        <el-time-picker
            v-model="form.start"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="选择时间"
          @change="hanldeUpdateForm"  
            >
        </el-time-picker>
       
        </el-form-item>
        <el-form-item label="准点：" >
            <el-time-picker
            v-model="form.ontime"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="选择时间"
            @change="hanldeUpdateForm"  
            >
        </el-time-picker>
        </el-form-item>
        <el-form-item label="结束：" >
            <el-time-picker
            v-model="form.end"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="选择时间"
            @change="hanldeUpdateForm"  
            >
        </el-time-picker>
        </el-form-item>
   
    </el-form>
    
</template>
<script>
export default{
    props:{
        row:{
            type:Object,
            default:()=>{}
        }
    },
    emits:['update:form'],
    data(){
        return {
            form:{
                start:'',
                ontime:'',
                end:''
            }
        }
    },
    mounted(){
        console.log(this.row,'mounted')
        this.form.start = this.row.start
        this.form.ontime = this.row.ontime
        this.form.end = this.row.end
    },

    methods:{
        hanldeUpdateForm(){
            console.log(this.form,'gengxion')
            this.$emit('update:form',this.form)
        }
    }
}
</script>
<style>
.dailt-form {
    width: auto;
    display: flex;
    flex-wrap: nowrap;
    gap: 8px 12px;
    justify-content: flex-start;
    align-items: center;
}

.dailt-form .el-form-item {
    margin-bottom: 0 !important;
    flex: 0 0 auto;
    min-width: 0;
}

.dailt-form .el-form-item .el-form-item__label {
    padding-right: 4px;
}

.dailt-form .el-form-item .el-date-editor.el-input,
.dailt-form .el-form-item .el-date-editor.el-input__inner {
    width: 118px;
}
</style>